<template>
  <div class="uk-section ba-tertiary-section">
    <div class="uk-container">
      <div class="uk-flex uk-flex-center" uk-grid>

        <div class="uk-width-1-1 uk-width-2-3@m uk-text-center">
          <h1 class="uk-h1 uk-margin-remove-bottom">Privacy Policy</h1>
          <h3 class="uk-h6 uk-margin-small-top">This Privacy Policy governs the manner in which BitAccel collects, uses, maintains, and discloses information collected from users (each, a "User") of the <router-link :to="{ name: 'home' }">https://bitaccel.com</router-link> website ("Site"). This privacy policy applies to the Site and all products and services offered by BitAccel.</h3>
        </div>

        <div class="uk-width-1-1 uk-width-2-3@m">
          <div class="uk-child-width-1-1" uk-grid>

            <div v-for="section in privacy_data" :key="section.id">
              <h2 class="uk-h2 uk-text-center">{{ section.id }}</h2>
              <ul class="uk-list uk-list-large uk-list-bullet">
                <template v-for="(item, index) in section.items">
                  <template v-if="item.sublist">
                    <li :key="index">
                      {{ item.sublist }}
                      <ul class="uk-list uk-list-bullet">
                        <li v-for="(subitem, subindex) in item.sublistitems" :key="subindex"> {{ subitem }}</li>
                      </ul>
                    </li>
                  </template>
                  <template v-else>
                    <li :key="index" class="uk-text-justify">{{ item }}</li>
                  </template>
                </template>
              </ul>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
	name: 'PrivacyPolicy',
	components: {
	},
	data () {
		return {
			privacy_data: [
				{
					id: 'Cookies',
					items: [
						"Your privacy is important to us. We do not use Cookies to 'enhance user experience' or any other marketing terms you can think of.",
						'We use only one Cookie, on our User Portal https://portal.bitaccel.com, which is used to persist your session.'
					]
				},
				{
					id: 'Personal Identification Information',
					items: [
						{
							sublist: 'We may collect personal identification information from Users in a variety of ways when Users:',
							sublistitems: [
								'register on our site',
								'place an order',
								'subscribe to our mailing list',
								'fill out a form'
							]
						},
						'This information is generally only collected in order to fulfill an order for a service',
						{
							sublist: 'Users may be asked for the following information when interacting with our site:',
							sublistitems: [
								'name',
								'email address',
								'billing address',
								'phone number'
							]
						},
						'We will only collect information that is voluntarily submitted. However, refusing to submit certain information, such as an email address, could prevent the User from using our service'
					]
				},
				{
					id: 'Right To Be Forgotten',
					items: [
						'We at BitAccel strongly beleive in the right to be forgotten. As such, we strive to make it as easy as possible for you to delete all of your personal information from our systems, while also keeping your information safe.',
						'To be forgotten, simply contact us either through the Contact Us page on our website or through the Portal ticketing system. Our team will be happy to process your request and remove all of your personal data from our system.',
						'Automated account/data deletion mechanisms will be released in a future update.'
					]
				},
				{
					id: 'How We Use Collected Personal Information',
					items: [
						{
							sublist: 'BitAccel uses collected personal information for the following purposes:',
							sublistitems: [
								'To process payments',
								'To communicte with the User',
								'To market'
							]
						}
					]
				},
				{
					id: 'How We Protect Your Information',
					items: [
						{
							sublist: 'We adopt appropriate data collection, storage, processing practices, and security measures to protect against unauthorized access, alteration, disclosure, or destruction of your personal data on our Site, including:',
							sublistitems: [
								'All data exchange between the User and us is encrypted',
								'All stored data is encrypted',
								'All data exchange between us and our payment processors is encrypted',
								'Access to stored data is only granted to employees of BitAccel and on a need-to-know basis'
							]
						},
						'Our Site is in compliance with PCI vulnerability standards'
					]
				},
				{
					id: 'Sharing Your Personal Information',
					items: [
						{
							sublist: 'We do not sell, trade, rent, or otherwise disclose any personal information to any third parties, except for:',
							sublistitems: [
								'We share billing information with our payment processors only for the purposes of processing a payment. Any payment processor we use is GDPR compliant.'
							]
						}
					]
				},
				{
					id: 'Changes To Our Policy',
					items: [
						'BitAccel has the discretion to update this privacy policy at any time. When we do, we will notify all Users via the email provided of our changes.',
						'If you have any questions about this Privacy Policy, the practices of this site, or your dealings with this site, please contact us via our Contact form or by emailing support@bitaccel.com'
					]
				}
			]
		}
	},
	metaInfo: {
		title: 'BitAccel | Privacy Policy'
	}
}
</script>

<style scoped lang="less">
  @import '../../assets/less/theme.less';

  .uk-h2 {
    color: @ba-gold !important;
  }
</style>
